<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Categories</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Categories</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <a
              href="javascript:void(0)"
              class="btn btn-info"
              @click="showFilter = !showFilter"
              ><i class="fa fa-filter"></i>Filter</a
            >
            <div class="card-tools">
              <router-link
                :to="{ name: 'CategoryCreate' }"
                class="btn btn-success"
                ><i class="fas fa-plus"></i> New
              </router-link>
            </div>
          </div>
          <form @submit.prevent="getItems" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="name"
                      >Name</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="name"
                        class="form-control"
                        v-model="filter.name"
                        placeholder="Name"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="parent_category">Parent category</label>
                    <div class="col-md-9">
                      <el-select
                        v-model="filter.parent_category"
                        name="parent_category"
                        id="parent_category"
                        placeholder="Select parent category"
                        style="width: 100%"
                      >
                        <el-option v-for="parent_category in parent_categories" :key="parent_category.id"
                                   :label="parent_category.title"
                                   :value="parent_category.id"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn btn-common m-2px">
                        Search
                      </button>
                      <button
                        type="reset"
                        class="btn btn-warning"
                        @click="resetFilter()"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body table-responsive-md p-0">
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 10px">ID</th>
                  <th>Category name</th>
                  <th>Slug</th>
                  <th>Display order</th>
                  <th>Parent category</th>
                  <th>Is Popular</th>
                  <th>Status</th>
                  <th class="text-right">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in items.data">
                  <td>{{ item.id }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.slug }}</td>
                  <td>{{ item.display_order }}</td>
                  <td>{{ item.parent_category.title }}</td>
                  <td>
                    <span class="badge bg-success" v-if="item.is_popular"
                      >Yes</span
                    >
                    <span class="badge bg-danger" v-else>No</span>
                  </td>
                  <td>
                    <span
                      class="badge bg-success"
                      v-if="item.status === 'active'"
                      >Active</span
                    >
                    <span class="badge bg-danger" v-else>In active</span>
                  </td>
                  <td class="text-right">
                    <router-link
                      :to="{ name: 'CategoryShow', params: { id: item.id } }"
                      class="btn btn-info btn-sm m-2px"
                    >
                      <i class="fas fa-eye"></i>
                    </router-link>
                    <router-link
                      :to="{ name: 'CategoryEdit', params: { id: item.id } }"
                      class="btn btn-info btn-sm m-2px"
                    >
                      <i class="fas fa-pencil-alt"></i>
                    </router-link>
                    <!--<button class="btn btn-danger btn-sm m-2px" @click="destroy(item.id, index)">
                    <i class="fas fa-trash"></i></button>-->
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="p-4" v-if="_.isEmpty(items.data)">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
          <div class="card-footer">
            <vue-pagination
              :pagination="items"
              v-if="items.total > items.per_page"
              @paginate="getItems()"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import { CategoryAPI } from "@/services/api";
import axios from "axios";

export default {
  name: "CategoryList",
  metaInfo: {
    title: "Category List | Dotlines",
  },
  components: {
    VuePagination,
  },
  data: () => ({
    items: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    showFilter: false,
    filter: {},
    is_loading: false,
    parent_categories: {},
  }),
  methods: {
    getItems() {
      this.is_loading = true;
      let query = { ...this.filter, ...this.$route.query };
      CategoryAPI.index(query)
        .then((items) => {
          this.items = items;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    resetFilter() {
      this.items.current_page = 1;
      this.filter = {};
      this.showFilter = false;
      this.getItems();
    },
    destroy(id, index) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          confirmButtonText: "Yes, delete it!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.is_loading = true;
            CategoryAPI.destroy(id)
              .then((response) => {
                this.items.data.splice(index, 1);
                this.items.total--;
                this.$toaster.success(response.message);
              })
              .catch((error) => {
                console.log("Could not delete this:: ", error);
                this.$swal.fire("Failed!", "Failed to delete.", "error");
              })
              .finally(() => {
                this.is_loading = false;
              });
          }
        });
    },
    getParentCategory() {
      axios
        .get('/parent_categories')
        .then((response) => {
          // console.log('parent_categories: ', response.data.data);
          this.parent_categories = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error.response);
        })
    }
  },
  async mounted() {
    await this.getItems();
    await this.getParentCategory();
  },
};
</script>
